import { createSVGWrapper } from "./SVGWrapper";

/**
 * @deprecated This icon is deprecated. Please use Lucide React icons instead.
 * @see https://lucide.dev/ for available icons
 * @example
 * import { Moon } from "lucide-react";
 * // Use <Moon /> instead
 */
export const DarkModeIcon = createSVGWrapper(
  <path
    fill="currentColor"
    d="M20.193 15.731A9 9 0 0 1 9.808 3.269a9 9 0 1 0 10.385 12.462Z"
  />
);
